/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface InsertDeviceMaintenanceStatusRequest
 */
export interface InsertDeviceMaintenanceStatusRequest {
    /**
     *
     * @type {string}
     * @memberof InsertDeviceMaintenanceStatusRequest
     */
    status?: InsertDeviceMaintenanceStatusRequestStatusEnum;
    /**
     *
     * @type {string}
     * @memberof InsertDeviceMaintenanceStatusRequest
     */
    notes?: string;
    /**
     * Currently set for Rectified status only.
     * @type {string}
     * @memberof InsertDeviceMaintenanceStatusRequest
     */
    subStatus?: InsertDeviceMaintenanceStatusRequestSubStatusEnum;
    /**
     * User-entered date this occurred (as opposed to when it was logged).
     * @type {Date}
     * @memberof InsertDeviceMaintenanceStatusRequest
     */
    actionedAt?: Date;
}

/**
 * @export
 */
export const InsertDeviceMaintenanceStatusRequestStatusEnum = {
    NotRectified: "NotRectified",
    Rectified: "Rectified",
    Other: "Other",
    Decommissioned: "Decommissioned",
} as const;
export type InsertDeviceMaintenanceStatusRequestStatusEnum =
    (typeof InsertDeviceMaintenanceStatusRequestStatusEnum)[keyof typeof InsertDeviceMaintenanceStatusRequestStatusEnum];

/**
 * @export
 */
export const InsertDeviceMaintenanceStatusRequestSubStatusEnum = {
    Other: "Other",
    RectifiedDuet: "Rectified_Duet",
    RectifiedCommissions: "Rectified_Commissions",
    RectifiedOnsiteTech: "Rectified_OnsiteTech",
} as const;
export type InsertDeviceMaintenanceStatusRequestSubStatusEnum =
    (typeof InsertDeviceMaintenanceStatusRequestSubStatusEnum)[keyof typeof InsertDeviceMaintenanceStatusRequestSubStatusEnum];

/**
 * Check if a given object implements the InsertDeviceMaintenanceStatusRequest interface.
 */
export function instanceOfInsertDeviceMaintenanceStatusRequest(
    value: object,
): value is InsertDeviceMaintenanceStatusRequest {
    return true;
}

export function InsertDeviceMaintenanceStatusRequestFromJSON(
    json: any,
): InsertDeviceMaintenanceStatusRequest {
    return InsertDeviceMaintenanceStatusRequestFromJSONTyped(json, false);
}

export function InsertDeviceMaintenanceStatusRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): InsertDeviceMaintenanceStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        status: json["status"] == null ? undefined : json["status"],
        notes: json["notes"] == null ? undefined : json["notes"],
        subStatus: json["subStatus"] == null ? undefined : json["subStatus"],
        actionedAt:
            json["actionedAt"] == null
                ? undefined
                : new Date(json["actionedAt"]),
    };
}

export function InsertDeviceMaintenanceStatusRequestToJSON(
    value?: InsertDeviceMaintenanceStatusRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        status: value["status"],
        notes: value["notes"],
        subStatus: value["subStatus"],
        actionedAt:
            value["actionedAt"] == null
                ? undefined
                : value["actionedAt"].toISOString(),
    };
}
